"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shisell_1 = require("shisell");
var customWriter = function () { };
var analyticsDispatcher = shisell_1.createRootDispatcher(function (eventModel) { return customWriter(eventModel); });
exports.default = {
    get dispatcher() {
        return analyticsDispatcher;
    },
    transformDispatcher: function (dispatcherTransformFunc) {
        analyticsDispatcher = dispatcherTransformFunc(analyticsDispatcher);
    },
    setWriter: function (func) {
        customWriter = func;
    },
};
